import { createContext } from "react";

const FirebaseAuthContext = createContext();

export default FirebaseAuthContext;
